module.exports = __webpack_public_path__ + "img/anambra.55b830d9.png";